export default __webpack_public_path__ + "static/BH_Complaints_Procedure-3b3a13016b740cfec65b4bb31606a566.pdf";